
import { useRef, useState } from 'react';
import Icon from '../utils/Icon';
import Flex from '../utils/Flex';
import IconBox from '../icons/IconBox';
import useClickOutside from '../../hooks/useClickOutside';

import './Video.scss'
import PlayCircle from '../../assets/images/play-circle.png'

const Video = ({ video }) => {

	const modalRef = useRef(null)
	const [modal, setModal] = useState(false)

	useClickOutside(modalRef, () => { setModal(false) })

	return (
		<div className="video rounded-xl bg-primary p-2">
			<div className="h-52 rounded-xl relative overflow-hidden">
				<img
					alt={video.title}
					src={video.thumbnail}
					className="video__thumbnail w-full object-cover object-center"
				/>
				{modal ? (
					<div ref={modalRef}>
						<Flex
							center
							className="video__modal absolute inset-0 z-10"
						>
							<Flex center className="bg-yellow-accent2 flex-1 py-2">
								<span className="font-bold text-black text-base">
									Open for {video.price}
								</span>
								<Icon
									name="box"
									className="h-10 w-16 mx-2"
									fill="black"
									stroke="none"
								>
									<IconBox />
								</Icon>
								<span className="font-bold text-black text-base">
									Video {video.duration}
								</span>
							</Flex>
						</Flex>
					</div>
				) : (
					<Flex center className="absolute inset-0">
						<img
							src={PlayCircle}
							alt='Video thumbnail'
							onClick={() => setModal(true)}
							className="video__play w-14 h-14 absolute cursor-pointer"
						/>
					</Flex>
				)}
				<span className="absolute bottom-3 right-3">
					<strong>HD</strong>
					{video.duration}
				</span>
			</div>
			<div>
				<h4 className="text-xl font-bold mt-3">{video.title}</h4>
				<p className="text-base">{video.date}</p>
			</div>
		</div >
	)
}

export default Video